import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-8">
      {icon && (
        <div className="w-12 h-12 rounded-xl bg-canvas border border-border flex items-center justify-center text-muted mb-4">
          {icon}
        </div>
      )}
      <p className="text-[15px] font-semibold text-text mb-1.5">{title}</p>
      {description && (
        <p className="text-sm text-muted max-w-xs leading-relaxed mb-5">
          {description}
        </p>
      )}
      {action}
    </div>
  );
}
